////////////////////
// Template
////////////////////
const template = /*html*/ `
    <div v-if="products.length > 0">
        <div class="o-container">
            <div  class="c-product-recommendations">
                <h2 class="c-product-recommendations_title || c-label">
                    <span class="c-label_diagonal">//</span>
                    <slot name="title"></slot>
                </h2>

                <div class="c-product-recommendations_grid || c-product-list">
                    <div v-for="(product, index) in products" :key="index" class="c-product-recommendations_grid_item">
                        <product-recommendations-item
                            ref="tile"
                            :title="product.title"
                            :images="product.images"
                            :handle="product.handle"
                            :created-at="product.createdAt"
                            :price-range="{ maxVariantPrice: product.price_max, minVariantPrice: product.price_min}"
                            :available-for-sale="product.available"
                            :currency-iso-code="currencyIsoCode"
                            :currency-symbol="currencySymbol"
                            :not-available-label="notAvailableLabel"
                            :new-label="newLabel"
                            :add-to-cart-label="addToCartLabel"
                            :go-to-product-label="goToProductLabel"
                            :variants-obj="product.variants"
                            :current-lang-code="currentLangCode"
                            :product-url="product.url"
                            :imageUrl="product.featured_image"
                            :alternativeImageUrl="product.images[1] || ''"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
`;


////////////////////
// Scripts
////////////////////
import { Swiper, Pagination, Navigation } from 'swiper';

export default function VueProductRecommendations(moduleInstance) {

    const THUMBNAIL_WIDTH = 1200;

    Vue.component("product-recommendations", {

        template,

        props: {
            productId: {
                type: String,
                required: true
            },
            currencyIsoCode: {
                type: String,
                required: true
            },
            currencySymbol: {
                type: String,
                required: true
            },
            notAvailableLabel: {
                type: String,
                required: true
            },
            newLabel: {
                type: String,
                required: true
            },
            addToCartLabel: {
                type: String,
                required: true
            },
            goToProductLabel: {
                type: String,
                required: true
            },
            currentLangCode: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                products: []
            };
        },

        computed: {
            limitProducts() {
                return this.products.slice(0, 3);
            }
        },

        created() {
            Swiper.use([Pagination, Navigation]);
        },

        async mounted() {
            const products = await moduleInstance.getProductRecommandations(this.productId);

            if (typeof products === 'object' && products.length > 0) {
                this.products = products
            }
        },


        methods: {
            /////////////////
            // Callbacks
            /////////////////
        },
    });
}
